"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var LapProblem_exports = {};
__export(LapProblem_exports, {
  default: () => LapProblem_default
});
module.exports = __toCommonJS(LapProblem_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.9141 15.4648L15.207 16.832L11.8281 15.8945C10.8906 15.7383 10.1029 15.3737 9.46484 14.8008C8.83984 14.2279 8.52734 13.5703 8.52734 12.8281C8.52734 11.9557 8.93099 11.2135 9.73828 10.6016C10.5586 9.98958 11.5482 9.68359 12.707 9.68359C13.8529 9.68359 14.8294 9.98958 15.6367 10.6016C16.457 11.2135 16.8672 11.9557 16.8672 12.8281C16.8672 13.388 16.6849 13.9023 16.3203 14.3711C15.9688 14.8268 15.5 15.1914 14.9141 15.4648ZM5.30469 15.1914L5.77344 13.1602C4.86198 12.7435 4.1263 12.1901 3.56641 11.5C3.00651 10.8099 2.72656 10.0482 2.72656 9.21484C2.72656 8.5638 2.89583 7.95833 3.23438 7.39844C3.57292 6.82552 4.03516 6.33073 4.62109 5.91406C5.22005 5.48438 5.91016 5.14583 6.69141 4.89844C7.48568 4.66406 8.33203 4.54688 9.23047 4.54688C10.1289 4.54688 10.9753 4.66406 11.7695 4.89844C12.5638 5.14583 13.2539 5.48438 13.8398 5.91406C14.4258 6.33073 14.8945 6.82552 15.2461 7.39844C15.5846 7.95833 15.7539 8.5638 15.7539 9.21484C15.7539 9.30599 15.7474 9.39714 15.7344 9.48828C15.7214 9.57943 15.7083 9.67057 15.6953 9.76172C15.2786 9.51432 14.8164 9.31901 14.3086 9.17578C13.8008 9.03255 13.2669 8.96094 12.707 8.96094C12.0299 8.96094 11.3919 9.05859 10.793 9.25391C10.194 9.46224 9.67318 9.74219 9.23047 10.0938C8.78776 10.4453 8.4362 10.8555 8.17578 11.3242C7.91536 11.793 7.78516 12.2943 7.78516 12.8281C7.78516 13.1016 7.82422 13.375 7.90234 13.6484C7.98047 13.9089 8.09115 14.1628 8.23438 14.4102L5.30469 15.1914ZM1.33984 19.4102H19.6602V1.08984H1.33984V19.4102Z",
      fill: "currentColor"
    }
  )
);
const SvgLapProblem = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var LapProblem_default = SvgLapProblem;
